import { combineReducers } from 'redux';
import { authReducer } from './authReducer';
import { catalogReducer } from './catalogReducer';
import { uiReducer } from './uiReducer';
import { ActionTypes } from '../actions/actionTypes';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { catelogViewsReducer } from './catelogViewsReducer';

const appReducer = combineReducers({
  catalog: catalogReducer,
  auth: authReducer,
  ui: uiReducer,
  catelogView: catelogViewsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === ActionTypes.REMOVE_USER) {
    state = undefined;
    storage.removeItem('persist:root-store-brand');
  }
  return appReducer(state, action);
};

export default rootReducer;
